<div
  class="relative md:sticky bottom-0 w-full left-0 flex flex-row border-t bg-slate-200 dark:bg-slate-700 border-slate-200 p-4 control-panel z-50"
  [ngClass]="{
    'justify-end': buttonPosition === 'end',
    'justify-center': buttonPosition === 'center',
    'justify-between': buttonPosition === 'between',
    'justify-start': buttonPosition === 'start'
  }"
  *ngIf="visibleButtons.length > 0">

  <div class="flex flex-row gap-2">
    <button
      *ngFor="let button of visibleButtons"
      mat-flat-button
      [color]="button.color"
      [disabled]="!button.enabled"
      [ngClass]="getButtonClasses(button)"
      (click)="onButtonClick(button)">

      <mat-icon
        *ngIf="button.icon"
        class="icon-size-5 text-current"
        [svgIcon]="button.icon">
      </mat-icon>

      <span
        class="ml-2 mr-1"
        [class.ml-0]="!button.icon">
        {{ button.label }}
      </span>
    </button>
  </div>
</div>
